<template>
  <Layout1 class="AttendanceInformation">
    <template slot="slot_title">
      <!-- <Select :defaultValue="store" @input="store=$event" class="select" :width="'165px'">
        <option v-for="(rest, r) in restaurants" :key="`rest-${r}`" :value="rest">{{rest}}</option>
      </Select> -->
      <Select :defaultValue="type" @input="type=$event" class="select" :width="'165px'">
        <option :value="'內場'">內場</option>
        <option :value="'外場'">外場</option>
      </Select>
      <div :style="{display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '10px'}">
        <input type="radio" v-model="daterange" value="本月" before="本月" @click="() => {
          range = {
            start: moment().startOf('month').format('yyyy-MM-DD'),
            end: moment().endOf('day').format('yyyy-MM-DD')
          }
        }">
        <input type="radio" v-model="daterange" value="自訂時間" before="自訂時間" @click="rangeSelect=true">
        <input type="text" class="search" v-model="searchText" placeholder="搜尋">
        <button class="addTeam export" @click="toExcel">匯出</button>
      </div>
      <div class="customDate" v-if="daterange==='自訂時間'&&rangeSelect===true">
          <vue-ctk-date-time-picker :range="true" v-model="range"
          :color="'var(--color-pri)'"
          :no-label="true"
          :input-size="'sm'"
          :label="'選取時間範圍'"
          :format="'YYYY-MM-DD'"
          :formatted="'YYYY-MM-DD'"/>
          <button @click="rangeSelect=false"></button>
      </div>
      <div class="boxToggle" :style="{marginLeft: 'auto'}" :hidden="open">
        <div  @click="open=true"><div class="toggle" :style="{transform: 'rotate(180deg)'}"></div>數值設定</div>
      </div>
      <div class="boxabs" :hidden="!open">
        <div @click="open=false"><div class="toggle"></div>數值設定</div>
        <div class="inputs">
          <div class="money" label="總獎金"><input type="text" id="bonus"></div>
          <div class="persentage" label="外場分配率"><input type="text" id="pfront"></div>
          <div class="persentage" label="內場分配率"><input type="text" id="pback"></div>
          <div class="x" label="加成倍數"><input type="text" :value="cross" id="cross"></div>
        </div>
        <div class="btns">
          <button class="cancelBtn" @click="open=false">取消</button>
          <button class="saveBtn" @click="setValue">套用</button>
        </div>
      </div>
    </template>
    <table ref="toExcel" v-show="type==='外場'">
      <thead>
        <tr>
          <th v-for="(field, i) in fields" :key="`field-${i}`" :style="{width: `${fieldsWidth[i]}`, textAlign: fieldsAlign[i]}" v-html="field"></th>
        </tr>
      </thead>
      <tbody v-if="datas">
        <tr v-for="(item, it) in datas.front.filter(e => !searchText || new RegExp(searchText, 'i').test(e.name))" :key="`item-${it}`" @click="itemSelect=it" :class="it===itemSelect?'selected':''">
          <td :style="{width: `${fieldsWidth[0]}`, textAlign: fieldsAlign[0]}">{{item.name}}</td>
          <td :style="{width: `${fieldsWidth[1]}`, textAlign: fieldsAlign[1]}">{{item.count?item.count.toFixed(1):'-'}}</td>
          <td :style="{width: `${fieldsWidth[2]}`, textAlign: fieldsAlign[2]}">{{item.add?item.add.toFixed(1):'-'}}</td>
          <td :style="{width: `${fieldsWidth[3]}`, textAlign: fieldsAlign[3], backgroundColor: 'rgba(191, 227, 245, 0.2)'}">{{(item.count+item.add*cross).toFixed(1)}}</td>
          <td :style="{width: `${fieldsWidth[4]}`, textAlign: fieldsAlign[4]}">{{datas.front_org.toFixed(0)}}</td>
          <td :style="{width: `${fieldsWidth[5]}`, textAlign: fieldsAlign[5]}">{{datas.front_add.toFixed(1)}}</td>
          <td :style="{width: `${fieldsWidth[6]}`, textAlign: fieldsAlign[6]}">{{frontTotal}}</td>
          <td :style="{width: `${fieldsWidth[7]}`, textAlign: fieldsAlign[7], backgroundColor: 'rgba(191, 227, 245, 0.2)'}">{{frontTotal?`${(((item.count+item.add*cross)/frontTotal*100).toFixed(1))}%`:'-'}}</td>
          <td :style="{width: `${fieldsWidth[8]}`, textAlign: fieldsAlign[8]}">{{bouns?bouns:'-'}}</td>
          <td :style="{width: `${fieldsWidth[9]}`, textAlign: fieldsAlign[9]}">{{pfront?`${pfront*100}%`:'-'}}</td>
          <td :style="{width: `${fieldsWidth[10]}`, textAlign: fieldsAlign[10]}">{{bouns ? Math.floor(bouns*pfront) : '-'}}</td>
          <td :style="{width: `${fieldsWidth[10]}`, textAlign: fieldsAlign[11]}">{{bouns ? `$${Math.floor(Math.floor(bouns*pfront)*((item.count+item.add*cross)/frontTotal))}` : '-'}}</td>
        </tr>
        <tr class="total">
          <td :style="{width: `${fieldsWidth[0]}`, textAlign: fieldsAlign[0], fontWeight: 900}">正職合計</td>
          <td :style="{width: `${fieldsWidth[1]}`, textAlign: fieldsAlign[1], fontWeight: 900}">{{datas.front.map(e => e.count).reduce((a, b) => a + b, 0).toFixed(1)}}</td>
          <td :style="{width: `${fieldsWidth[2]}`, textAlign: fieldsAlign[2], fontWeight: 900}">{{datas.front.map(e => e.add).reduce((a, b) => a + b, 0).toFixed(1)}}</td>
          <td :style="{width: `${fieldsWidth[3]}`, textAlign: fieldsAlign[3], fontWeight: 900}">{{datas.front.map(e => (e.count+e.add*cross)).reduce((a, b) => a + b, 0).toFixed(1)}}</td>
          <td :style="{width: `${fieldsWidth[4]}`, textAlign: fieldsAlign[4]}">{{datas.front_org.toFixed(0)}}</td>
          <td :style="{width: `${fieldsWidth[5]}`, textAlign: fieldsAlign[5]}">{{datas.front_add.toFixed(1)}}</td>
          <td :style="{width: `${fieldsWidth[6]}`, textAlign: fieldsAlign[6]}">{{frontTotal}}</td>
          <td :style="{width: `${fieldsWidth[7]}`, textAlign: fieldsAlign[7], fontWeight: 900}">{{frontTotal?`${((datas.front.map(e => (e.count+e.add*cross)).reduce((a, b) => a + b, 0)/frontTotal*100).toFixed(1))}%`: '-'}}</td>
          <td :style="{width: `${fieldsWidth[8]}`, textAlign: fieldsAlign[8]}">{{bouns?bouns:'-'}}</td>
          <td :style="{width: `${fieldsWidth[9]}`, textAlign: fieldsAlign[9]}">{{pfront?`${pfront*100}%`:'-'}}</td>
          <td :style="{width: `${fieldsWidth[10]}`, textAlign: fieldsAlign[10]}">{{bouns ? Math.floor(bouns*pfront) : '-'}}</td>
          <td :style="{width: `${fieldsWidth[10]}`, textAlign: fieldsAlign[11], fontSize: '28px', fontWeight: 900}">{{bouns ? `$${datas.front.map(e => Math.floor(Math.floor(bouns*pfront)*(e.count+e.add*cross)/frontTotal)).reduce((a, b) => a + b, 0)}`: '-'}}</td>
        </tr>
        <tr v-for="(item, it) in datas.frontPT.filter(e => !searchText || new RegExp(searchText, 'i').test(e.name))" :key="`item-PT-${it}`" @click="itemSelect2=it" :class="it===itemSelect2?'selected':''">
          <td :style="{width: `${fieldsWidth[0]}`, textAlign: fieldsAlign[0]}">{{item.name}}</td>
          <td :style="{width: `${fieldsWidth[1]}`, textAlign: fieldsAlign[1]}">{{item.count?item.count.toFixed(1):'-'}}</td>
          <td :style="{width: `${fieldsWidth[2]}`, textAlign: fieldsAlign[2]}">{{item.add?item.add.toFixed(1):'-'}}</td>
          <td :style="{width: `${fieldsWidth[3]}`, textAlign: fieldsAlign[3], backgroundColor: 'rgba(191, 227, 245, 0.2)'}">{{(item.count+item.add*cross)?(item.count+item.add*cross).toFixed(1):'-'}}</td>
          <td :style="{width: `${fieldsWidth[4]}`, textAlign: fieldsAlign[4]}">{{datas.front_org.toFixed(0)}}</td>
          <td :style="{width: `${fieldsWidth[5]}`, textAlign: fieldsAlign[5]}">{{datas.front_add.toFixed(1)}}</td>
          <td :style="{width: `${fieldsWidth[6]}`, textAlign: fieldsAlign[6]}">{{frontTotal}}</td>
          <td :style="{width: `${fieldsWidth[7]}`, textAlign: fieldsAlign[7], backgroundColor: 'rgba(191, 227, 245, 0.2)'}">{{frontTotal?`${(((item.count+item.add*cross)/frontTotal*100).toFixed(1))}%`:'-'}}</td>
          <td :style="{width: `${fieldsWidth[8]}`, textAlign: fieldsAlign[8]}">{{bouns?bouns:'-'}}</td>
          <td :style="{width: `${fieldsWidth[9]}`, textAlign: fieldsAlign[9]}">{{pfront?`${pfront*100}%`:'-'}}</td>
          <td :style="{width: `${fieldsWidth[10]}`, textAlign: fieldsAlign[10]}">{{bouns ? Math.floor(bouns*pfront) : '-'}}</td>
          <td :style="{width: `${fieldsWidth[10]}`, textAlign: fieldsAlign[11]}">{{bouns ? `$${Math.floor(Math.floor(bouns*pfront)*((item.count+item.add*cross)/frontTotal))}` : '-'}}</td>
        </tr>
        <tr class="total">
          <td :style="{width: `${fieldsWidth[0]}`, textAlign: fieldsAlign[0], fontWeight: 900}">PT合計</td>
          <td :style="{width: `${fieldsWidth[1]}`, textAlign: fieldsAlign[1], fontWeight: 900}">{{datas.frontPT.map(e => e.count).reduce((a, b) => a + b, 0).toFixed(1)}}</td>
          <td :style="{width: `${fieldsWidth[2]}`, textAlign: fieldsAlign[2], fontWeight: 900}">{{datas.frontPT.map(e => e.add).reduce((a, b) => a + b, 0).toFixed(1)}}</td>
          <td :style="{width: `${fieldsWidth[3]}`, textAlign: fieldsAlign[3], fontWeight: 900}">{{datas.frontPT.map(e => (e.count+e.add*cross)).reduce((a, b) => a + b, 0).toFixed(1)}}</td>
          <td :style="{width: `${fieldsWidth[4]}`, textAlign: fieldsAlign[4]}">{{datas.front_org.toFixed(0)}}</td>
          <td :style="{width: `${fieldsWidth[5]}`, textAlign: fieldsAlign[5]}">{{datas.front_add.toFixed(1)}}</td>
          <td :style="{width: `${fieldsWidth[6]}`, textAlign: fieldsAlign[6]}">{{frontTotal}}</td>
          <td :style="{width: `${fieldsWidth[7]}`, textAlign: fieldsAlign[7], fontWeight: 900}">{{frontTotal? `${((datas.frontPT.map(e => (e.count+e.add*cross)).reduce((a, b) => a + b, 0)/frontTotal*100).toFixed(1))}%`:'-'}}</td>
          <td :style="{width: `${fieldsWidth[8]}`, textAlign: fieldsAlign[8]}">{{bouns?bouns:'-'}}</td>
          <td :style="{width: `${fieldsWidth[9]}`, textAlign: fieldsAlign[9]}">{{pfront?`${pfront*100}%`:'-'}}</td>
          <td :style="{width: `${fieldsWidth[10]}`, textAlign: fieldsAlign[10]}">{{bouns ? Math.floor(bouns*pfront) : '-'}}</td>
          <td :style="{width: `${fieldsWidth[10]}`, textAlign: fieldsAlign[11], fontSize: '28px', fontWeight: 900}">{{bouns ? `$${datas.frontPT.map(e => Math.floor(Math.floor(bouns*pfront)*(e.count+e.add*cross)/frontTotal)).reduce((a, b) => a + b, 0)}` : '-'}}</td>
        </tr>
      </tbody>
    </table>
    <table ref="toExcel2" v-show="type==='內場'">
      <thead>
        <tr>
          <th v-for="(field, i) in fields2" :key="`field-${i}`" :style="{width: `${fieldsWidth[i]}`, textAlign: fieldsAlign[i]}" v-html="field"></th>
        </tr>
      </thead>
      <tbody v-if="datas">
        <tr v-for="(item, it) in datas.back.filter(e => !searchText || new RegExp(searchText, 'i').test(e.name))" :key="`item-back-${it}`" @click="itemSelect=it" :class="it===itemSelect?'selected':''">
          <td :style="{width: `${fieldsWidth[0]}`, textAlign: fieldsAlign[0]}">{{item.name}}</td>
          <td :style="{width: `${fieldsWidth[1]}`, textAlign: fieldsAlign[1]}">{{item.count?item.count.toFixed(1):'-'}}</td>
          <td :style="{width: `${fieldsWidth[2]}`, textAlign: fieldsAlign[2]}">{{item.add?item.add.toFixed(1):'-'}}</td>
          <td :style="{width: `${fieldsWidth[3]}`, textAlign: fieldsAlign[3], backgroundColor: 'rgba(191, 227, 245, 0.2)'}">{{(item.count+item.add*cross)?(item.count+item.add*cross).toFixed(1):'-'}}</td>
          <td :style="{width: `${fieldsWidth[4]}`, textAlign: fieldsAlign[4]}">{{datas.back_org.toFixed(0)}}</td>
          <td :style="{width: `${fieldsWidth[5]}`, textAlign: fieldsAlign[5]}">{{datas.back_add.toFixed(1)}}</td>
          <td :style="{width: `${fieldsWidth[6]}`, textAlign: fieldsAlign[6]}">{{backTotal}}</td>
          <td :style="{width: `${fieldsWidth[7]}`, textAlign: fieldsAlign[7], backgroundColor: 'rgba(191, 227, 245, 0.2)'}">{{backTotal?`${(((item.count+item.add*cross)/backTotal*100).toFixed(1))}%`:'-'}}</td>
          <td :style="{width: `${fieldsWidth[8]}`, textAlign: fieldsAlign[8]}">{{bouns?bouns:'-'}}</td>
          <td :style="{width: `${fieldsWidth[9]}`, textAlign: fieldsAlign[9]}">{{pback?`${pback*100}%`:'-'}}</td>
          <td :style="{width: `${fieldsWidth[10]}`, textAlign: fieldsAlign[10]}">{{bouns ? Math.floor(bouns*pback) : '-'}}</td>
          <td :style="{width: `${fieldsWidth[10]}`, textAlign: fieldsAlign[11]}">{{bouns ? `$${Math.floor(Math.floor(bouns*pback)*((item.count+item.add*cross)/backTotal))}` : '-'}}</td>
        </tr>
        <tr class="total">
          <td :style="{width: `${fieldsWidth[0]}`, textAlign: fieldsAlign[0], fontWeight: 900}">正職合計</td>
          <td :style="{width: `${fieldsWidth[1]}`, textAlign: fieldsAlign[1], fontWeight: 900}">{{datas.back.map(e => e.count).reduce((a, b) => a + b, 0).toFixed(1)}}</td>
          <td :style="{width: `${fieldsWidth[2]}`, textAlign: fieldsAlign[2], fontWeight: 900}">{{datas.back.map(e => e.add).reduce((a, b) => a + b, 0).toFixed(1)}}</td>
          <td :style="{width: `${fieldsWidth[3]}`, textAlign: fieldsAlign[3], fontWeight: 900}">{{datas.back.map(e => (e.count+e.add*cross)).reduce((a, b) => a + b, 0).toFixed(1)}}</td>
          <td :style="{width: `${fieldsWidth[4]}`, textAlign: fieldsAlign[4]}">{{datas.back_org.toFixed(0) }}</td>
          <td :style="{width: `${fieldsWidth[5]}`, textAlign: fieldsAlign[5]}">{{datas.back_add.toFixed(1) }}</td>
          <td :style="{width: `${fieldsWidth[6]}`, textAlign: fieldsAlign[6]}">{{backTotal }}</td>
          <td :style="{width: `${fieldsWidth[7]}`, textAlign: fieldsAlign[7], fontWeight: 900}">{{backTotal?`${((datas.back.map(e => (e.count+e.add*cross)).reduce((a, b) => a + b, 0)/backTotal*100).toFixed(1))}%`:'-'}}</td>
          <td :style="{width: `${fieldsWidth[8]}`, textAlign: fieldsAlign[8]}">{{bouns?bouns:'-'}}</td>
          <td :style="{width: `${fieldsWidth[9]}`, textAlign: fieldsAlign[9]}">{{pback?`${pback*100}%`:'-'}}</td>
          <td :style="{width: `${fieldsWidth[10]}`, textAlign: fieldsAlign[10]}">{{bouns ? Math.floor(bouns*pback) : '-'}}</td>
          <td :style="{width: `${fieldsWidth[10]}`, textAlign: fieldsAlign[11], fontSize: '28px', fontWeight: 900}">{{bouns ? `$${datas.back.map(e => Math.floor(Math.floor(bouns*pback)*(e.count+e.add*cross)/backTotal)).reduce((a, b) => a + b, 0)}` : '-'}}</td>
        </tr>
        <tr v-for="(item, it) in datas.backPT.filter(e => !searchText || new RegExp(searchText, 'i').test(e.name))" :key="`item-back-PT-${it}`" @click="itemSelect2=it" :class="it===itemSelect2?'selected':''">
          <td :style="{width: `${fieldsWidth[0]}`, textAlign: fieldsAlign[0]}">{{item.name}}</td>
          <td :style="{width: `${fieldsWidth[1]}`, textAlign: fieldsAlign[1]}">{{item.count?item.count.toFixed(1):'-'}}</td>
          <td :style="{width: `${fieldsWidth[2]}`, textAlign: fieldsAlign[2]}">{{item.add?item.add.toFixed(1):'-'}}</td>
          <td :style="{width: `${fieldsWidth[3]}`, textAlign: fieldsAlign[3], backgroundColor: 'rgba(191, 227, 245, 0.2)'}">{{(item.count+item.add*cross)?(item.count+item.add*cross).toFixed(1):'-'}}</td>
          <td :style="{width: `${fieldsWidth[4]}`, textAlign: fieldsAlign[4]}">{{datas.back_org.toFixed(0)}}</td>
          <td :style="{width: `${fieldsWidth[5]}`, textAlign: fieldsAlign[5]}">{{datas.back_add.toFixed(1)}}</td>
          <td :style="{width: `${fieldsWidth[6]}`, textAlign: fieldsAlign[6]}">{{backTotal}}</td>
          <td :style="{width: `${fieldsWidth[7]}`, textAlign: fieldsAlign[7], backgroundColor: 'rgba(191, 227, 245, 0.2)'}">{{backTotal?`${(((item.count+item.add*cross)/backTotal*100).toFixed(1))}%`:'-'}}</td>
          <td :style="{width: `${fieldsWidth[8]}`, textAlign: fieldsAlign[8]}">{{bouns?bouns:'-'}}</td>
          <td :style="{width: `${fieldsWidth[9]}`, textAlign: fieldsAlign[9]}">{{pback?`${pback*100}%`:'-'}}</td>
          <td :style="{width: `${fieldsWidth[10]}`, textAlign: fieldsAlign[10]}">{{bouns ? Math.floor(bouns*pback) : '-'}}</td>
          <td :style="{width: `${fieldsWidth[10]}`, textAlign: fieldsAlign[11]}">{{bouns ? `$${Math.floor(Math.floor(bouns*pback)*((item.count+item.add*cross)/backTotal))}` : '-'}}</td>
        </tr>
        <tr class="total">
          <td :style="{width: `${fieldsWidth[0]}`, textAlign: fieldsAlign[0], fontWeight: 900}">PT合計</td>
          <td :style="{width: `${fieldsWidth[1]}`, textAlign: fieldsAlign[1], fontWeight: 900}">{{datas.backPT.map(e => e.count).reduce((a, b) => a + b, 0).toFixed(1)}}</td>
          <td :style="{width: `${fieldsWidth[2]}`, textAlign: fieldsAlign[2], fontWeight: 900}">{{datas.backPT.map(e => e.add).reduce((a, b) => a + b, 0).toFixed(1)}}</td>
          <td :style="{width: `${fieldsWidth[3]}`, textAlign: fieldsAlign[3], fontWeight: 900}">{{datas.backPT.map(e => (e.count+e.add*cross)).reduce((a, b) => a + b, 0).toFixed(1)}}</td>
          <td :style="{width: `${fieldsWidth[4]}`, textAlign: fieldsAlign[4]}">{{datas.back_org.toFixed(0) }}</td>
          <td :style="{width: `${fieldsWidth[5]}`, textAlign: fieldsAlign[5]}">{{datas.back_add.toFixed(1) }}</td>
          <td :style="{width: `${fieldsWidth[6]}`, textAlign: fieldsAlign[6]}">{{backTotal }}</td>
          <td :style="{width: `${fieldsWidth[7]}`, textAlign: fieldsAlign[7], fontWeight: 900}">{{backTotal?`${((datas.backPT.map(e => (e.count+e.add*cross)).reduce((a, b) => a + b, 0)/backTotal*100).toFixed(1))}%`:'-'}}</td>
          <td :style="{width: `${fieldsWidth[8]}`, textAlign: fieldsAlign[8]}">{{bouns?bouns:'-'}}</td>
          <td :style="{width: `${fieldsWidth[9]}`, textAlign: fieldsAlign[9]}">{{pback?`${pback*100}%`:'-'}}</td>
          <td :style="{width: `${fieldsWidth[10]}`, textAlign: fieldsAlign[10]}">{{bouns ? Math.floor(bouns*pback) : '-'}}</td>
          <td :style="{width: `${fieldsWidth[10]}`, textAlign: fieldsAlign[11], fontSize: '28px', fontWeight: 900}">{{bouns ? `$${datas.backPT.map(e => Math.floor(Math.floor(bouns*pback)*(e.count+e.add*cross)/backTotal)).reduce((a, b) => a + b, 0)}` : '-'}}</td>
           <!-- Math.floor(bouns*pback)*((datas.backPT.map(e => (e.count+e.add*cross)).reduce((a, b) => a + b, 0)/datas.back_total).toFixed(1)) -->
        </tr>
      </tbody>
    </table>
  </Layout1>
</template>

<script>
import { mapState } from 'vuex'
import * as XLSX from 'xlsx'
import Layout1 from '../../components/layout/L1.vue'
import Select from '../../components/select.vue'
import { getapi } from '../../store/fetch'
export default {
  name: 'AttendanceSummary',
  components: { Layout1, Select },
  computed: {
    backTotal () {
      return parseInt((this.datas.backPT.map(e => (e.count + e.add * this.cross)).reduce((a, b) => a + b, 0) + this.datas.back.map(e => (e.count + e.add * this.cross)).reduce((a, b) => a + b, 0)).toFixed(0))
    },
    frontTotal () {
      return parseInt((this.datas.frontPT.map(e => (e.count + e.add * this.cross)).reduce((a, b) => a + b, 0) + this.datas.front.map(e => (e.count + e.add * this.cross)).reduce((a, b) => a + b, 0)).toFixed(0))
    },
    store () {
      return this.$route.query.store
    },
    ...mapState({ restaurants: 'restaurants' })
  },
  watch: {
    range () {
      if (this.range.start && this.range.end) {
        this.getusers()
      }
    }
  },
  mounted () {
    this.getusers()
  },
  methods: {
    toExcel () {
      const front = XLSX.utils.table_to_sheet(this.$refs.toExcel)
      const back = XLSX.utils.table_to_sheet(this.$refs.toExcel2)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, front, '外場')
      XLSX.utils.book_append_sheet(wb, back, '內場')
      XLSX.writeFile(wb, `餐廳業務統計_${this.moment(this.range.start).format('ggMMDD')}_${this.moment(this.range.end).format('ggMMDD')}.xlsx`)
    },
    setValue () {
      this.bouns = parseInt(document.getElementById('bonus').value)
      this.pfront = parseInt(document.getElementById('pfront').value) / 100
      this.pback = parseInt(document.getElementById('pback').value) / 100
      this.cross = parseFloat(document.getElementById('cross').value)
      this.open = false
    },
    async getusers () {
      const data = await getapi('restaurant/restAttendance?' + new URLSearchParams({
        start: this.moment(this.range.start).startOf('day').toISOString(),
        end: this.moment(this.range.end).endOf('day').toISOString(),
        store: this.store
      }))
      this.datas = data
    }
  },
  data () {
    return {
      type: '內場',
      rangeSelect: false,
      itemSelect: null,
      itemSelect2: null,
      searchText: null,
      datas: null,
      open: false,
      daterange: '本月',
      bouns: 0,
      pfront: 0,
      pback: 0,
      cross: 1,
      range: {
        start: this.moment().startOf('month').format('yyyy-MM-DD'),
        end: this.moment().endOf('day').format('yyyy-MM-DD')
      },
      fields: [
        '員工姓名',
        '原始服務人次',
        '加成服務人次',
        '個人總',
        '外場原始<br>總服務人次',
        '外場加成<br>總服務人次',
        '外場<br>總服務人次',
        '服務人次占比',
        '總獎金',
        '外場分配率',
        '外場獎金',
        '應發金額'
      ],
      fields2: [
        '員工姓名',
        '原始服務餐數',
        '加成服務餐數',
        '個人總',
        '內場原始<br>總服務餐數',
        '內場加成<br>總服務餐數',
        '內場<br>總服務餐數',
        '服務餐數占比',
        '總獎金',
        '內場分配率',
        '內場獎金',
        '應發金額'
      ],
      fieldsAlign: [
        'start',
        'center',
        'center',
        'center',
        'center',
        'center',
        'center',
        'center',
        'center',
        'center',
        'center',
        'center'
      ],
      fieldsWidth: [
        '160px',
        '110px',
        '110px',
        '110px',
        '110px',
        '110px',
        '110px',
        '144px',
        '110px',
        '110px',
        '110px',
        '110px'
      ]
    }
  }
}
</script>
<style lang="scss">
.AttendanceInformation {
  .field-input {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 18px!important;
    line-height: 36px;
    letter-spacing: 0.1em;
    color: var(--color-letter);
  }

}
</style>
<style lang="scss" scoped>
table {
  border-collapse: collapse;
}
table tbody tr, table tbody tr td {
  height: 64px;
}
thead tr {
  background-color: var(--color-infobox);
}
.btns {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 28px;
  margin-top: 23px;
}
.saveBtn, .cancelBtn {
width: 100px;
height: 35px;
background-color: #B8B8B8;
border-radius: 20px;
font-weight: 400;
font-size: 16px;
letter-spacing: 0.1em;
color: #FFFFFF;
border: none;
}
.saveBtn {
  background-color: #E37878;
}
.customDate {
  display: flex;
  position: fixed;
  top: 74px;
  left: 700px;
  width: 400px;
  height: 80px;
  box-shadow: 4px 0px 15px rgba(0, 0, 0, 0.25);
  margin-top: 10px;
  background-color: #FFFFFF;
  border-radius: 5px;
  z-index: 1;
  padding: 20px;
  box-sizing: border-box;
  button {
    height: 36px;
    width: 36px;
    border: none;
    padding: 0;
    background-color: transparent;
    &::before {
      content: '';
      display: inline-block;
      width: 36px;
      height: 36px;
      background-color: var(--color-checked);
      mask: center / 32px no-repeat url(/close.svg);
      font-size: 24px;
    }
  }
}
.inputs {
  &>div {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-inline: 10px;
    &::before {
      content: attr(label);
      display: inline-block;
      width: 145px;
      text-align: start;
    }
    &.money::after {
      content: '$';
      position: absolute;
      right: 124px;
      font-size: 16px;
    }
    &.persentage::after {
      content: '%';
      position: absolute;
      right: 48px;
      font-size: 16px;
    }
    &.x::after {
      content: '倍';
      position: absolute;
      right: 48px;
      font-size: 16px;
    }
    &.money>input[type=text] {
      padding-left: 32px;
      padding-right: 13px;
    }
    &.persentage>input[type=text] {
      padding-right: 36px;
    }
    &.x>input[type=text] {
      padding-right: 40px;
    }
    input[type=text] {
      width: 115px;
      height: 40px;
      box-sizing: border-box;
      border-radius: 3px;
      border: 1px solid #C4C4C4;
      text-indent: 12px;
      font-size: 18px;
      display: flex;
      align-items: center;
      text-align: end;
      color: #5E5E5E;
    }
  }
}
.toggle {
  width: 16px;
  height: 13px;
  background-color: var(--color-pri);
  mask: center / contain no-repeat url(/triangle.svg);
  transform: rotate(0deg);
}
.boxabs {
  position: absolute;
  top: 88px;
  width: 285px;
  height: 305px;
  right: 32px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
  background-color: var(--color-infobox);
  z-index: 200;
  padding: 0 20px 20px 20px;
  font-weight: 400;
  font-size: 18px;
  letter-spacing: 0.1em;
  color: var(--color-pri);
  &>div:nth-child(1) {
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;

  }
}
.boxToggle {
  width: 285px;
  height: 50px;
  background: var(--color-infobox);
  border-radius: 3px;
  font-weight: 400;
  font-size: 18px;
  letter-spacing: 0.1em;
  color: var(--color-pri);
  margin-right: 32px;
  padding-inline: 20px;
  &>div:nth-child(1) {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
  }
}
th, td {
  padding-inline: 5px;
  box-sizing: border-box;
  // border-right: 1px solid #C4C4C4;
  color: #5E5E5E;
  text-align: start;
  button {
    width: 40px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: transparent;
    border: none;
  }
}

th {
  font-family: Roboto;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  letter-spacing: 0.1em;
  color: #000000;
}
td {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  letter-spacing: 0.1em;
  color: var(--color-letter);
}
.total {
  background: rgba(227, 120, 120, 0.15);
}
.total>td {
  font-size: 24px;
}
.addTeam {
  width: 100px;
  height: 35px;
  background: var(--color-checked);
  border-radius: 20px;
  border: none;
  font-size: 16px;
  letter-spacing: 0.1em;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  &:disabled {
    filter: contrast(.5)
  }
  &::before {
    content: '';
    background-color: #FFFFFF;
    display: inline-block;
    width: 25px;
    height: 25px;
  }
  &.print::before {
    mask: center / contain no-repeat url(/print.svg);
  }
  &.export::before {
    mask: center / contain no-repeat url(/excel.svg);
  }
}
.search {
  width: 300px;
  height: 40px;
  box-sizing: border-box;
  background-image: url(/search.svg);
  background-position: calc(100% - 10px) 10px;
  background-repeat: no-repeat;
  border-radius: 3px;
  border: 1px solid #C4C4C4;
  text-indent: 12px;
  font-size: 18px;
  display: flex;
  align-items: center;
  &::placeholder {
    color: var(--color-border);
  }

}
select {
  box-sizing: border-box;
  width: 175px;
  height: 40px;
  border: 1px solid #C4C4C4;
  border-radius: 3px;
  text-indent: 12px;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  letter-spacing: 0.1em;
  color: var(--color-checked);
}
input[type=radio] {
  width: fit-content;
  padding-inline: 22px;
  height: 40px;
  background-color: var(--color-border);
  appearance: none;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  &::before {
    content: attr(value);
    font-family: Roboto;
    font-style: normal;
    font-weight: 900;
    font-size: 18px;
    letter-spacing: 0.1em;
    color: #FFFFFF;
  }
  &:checked {
    background-color: var(--color-checked);
  }
  &:hover {
    filter: contrast(.5);
  }
}
.AttendanceInformation {
padding-inline: 18px 9px!important;
table {
  min-height: 300px;
  width: calc(100% - 22px);
  tr {
    position: relative;
  }
  tr.selected {
    background: rgba(191, 227, 245, 0.2);
  }
  td, th {
    &:nth-child(1) {
      padding-left: 25px;
    }
  }
  td {
    &:last-child {
      color: #E37878;
    }
  }
}
.header {
  height: 89px;
  display: flex;
  align-items: center;
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 36px;
  line-height: 52px;
  color: var(--color-pri);
  letter-spacing: 0.15em;
  border-bottom: 1px solid var(--color-border);
  gap: 20px;
  span {
    display: inline-flex;
    align-items: center;
    gap: 10px;
  }
}
}
.box {
  width: 422px;
  height: 505px;
  min-height: 505px;
  border: 1px solid var(--color-pri);
  border-radius: 10px;
  box-sizing: border-box;
}
</style>
